import { i as m, x as a, j as h, s as y } from "../../../lit-element-6iugfgmM.js";
import { e as u } from "../../../custom-element-wk-AooBb.js";
import { n as l } from "../../../property-BWlAHqg_.js";
import "../../../query-assigned-elements-B8U94KLQ.js";
import "../../../sp-action-menu-DlUN8i8Y.js";
import "../../../sp-menu-item-BiHMHkza.js";
import "../../../sp-overlay-D-aFOzDh.js";
import "../../../sp-tooltip-DqxvQQTj.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-more.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-delete.js";
import "@spectrum-web-components/icons-workflow/icons/sp-icon-more-small-list-vert.js";
import { r as b } from "../../../slottable-request-event-B1mW6PN4.js";
import g, { DeleteLibraryEventType as f } from "../../../events/DeleteLibraryEvent.js";
import d from "../../../events/NotificationEvent.js";
import { Analytics as O } from "../../../lib/Analytics.js";
import { Localize as v } from "../../../lib/I18N.js";
import { h as _ } from "../../../Libraries-vcrwQoHF.js";
import "../delete-library-dialog/DeleteLibraryDialog.js";
const k = { "library-actions-menu.tooltip": "More actions", "library-actions-menu.delete": "Delete library", "library-actions-menu.delete-success": "{libraryName} deleted", "library-actions-menu.error-message": "There was an error deleting the library. Please try again later.", "library-actions-menu.undo": "Undo" }, D = m`sp-icon-delete,.title{color:var(--spectrum-global-color-red-500)}sp-action-menu[open]{--mod-actionbutton-background-color-default-selected: var(--spectrum-gray-200);--mod-actionbutton-content-color-default-selected: var(--spectrum-gray-900)}`;
var $ = Object.defineProperty, I = Object.getOwnPropertyDescriptor, s = (e, i, n, o) => {
  for (var p, t = o > 1 ? void 0 : o ? I(i, n) : i, c = e.length - 1; c >= 0; c--) (p = e[c]) && (t = (o ? p(i, n, t) : p(t)) || t);
  return o && t && $(i, n, t), t;
}, U = ((e) => (e.Delete = "delete", e))(U || {});
let r = class extends O(v(y, k)) {
  constructor() {
    super(...arguments), this.placement = "bottom-start", this.libraryIdOrUrn = "", this.libraryName = "", this.options = ["delete"], this._isFirstClickTracked = !1, this._handleDelete = async () => {
      try {
        await _(this.libraryIdOrUrn), this.dispatchEvent(new g({ type: f.Delete, libraryId: this.libraryIdOrUrn })), this.dispatchEvent(new d({ type: "success", message: this.t("library-actions-menu.delete-success", { libraryName: this.libraryName }) })), this.sendAnalyticsEvent("delete-library-success", { libraryIdOrUrn: this.libraryIdOrUrn });
      } catch (e) {
        this.dispatchEvent(new d({ type: "error", message: this.t("library-actions-menu.error-message") })), this.handleApiError(e, "libraries");
      }
    };
  }
  static get styles() {
    return D;
  }
  render() {
    return a`${this.renderDeleteOverlay()}<sp-action-menu label="${this.t("library-actions-menu.tooltip")}" quiet @click="${this._handleActionMenuClick}" placement="${this.placement}">${this.renderDeleteOption()}<sp-tooltip self-managed placement="top" slot="tooltip">${this.t("library-actions-menu.tooltip")}</sp-tooltip></sp-action-menu>`;
  }
  _handleActionMenuClick(e) {
    this._handleStopPropagation(e), this._isFirstClickTracked || (this.sendAnalyticsEvent("menu-open", { options: this.options }), this._isFirstClickTracked = !0);
  }
  _hasOption(e) {
    return this.options.includes(e);
  }
  _handleStopPropagation(e) {
    e.stopPropagation();
  }
  renderDeleteOption() {
    return this._hasOption("delete") ? a`<sp-menu-item id="delete" value="delete"><sp-icon-delete slot="icon"></sp-icon-delete><span class="title">${this.t("library-actions-menu.delete")}</span></sp-menu-item>` : a``;
  }
  renderDeleteOverlay() {
    return this._hasOption("delete") ? a`<sp-overlay trigger="delete@click" @slottable-request="${this._handleDeleteClick}" type="modal"></sp-overlay>` : a``;
  }
  _handleDeleteClick(e) {
    const i = e.data === b ? "" : a`<af-delete-library-dialog @click="${this._handleStopPropagation}" @delete="${this._handleDelete}" .libraryIdOrUrn="${this.libraryIdOrUrn}" .libraryName="${this.libraryName}"></af-delete-library-dialog>`;
    h(i, e.target);
  }
};
s([l()], r.prototype, "placement", 2), s([l()], r.prototype, "libraryIdOrUrn", 2), s([l()], r.prototype, "libraryName", 2), s([l()], r.prototype, "options", 2), r = s([u("af-library-actions-menu")], r);
const J = r;
export {
  U as LibraryActionsMenuOptions,
  J as default
};
//# sourceMappingURL=LibraryActionsMenu.js.map
